import { DictType } from "@pma/types";

import { Button } from "@components/common/button";
import { RefreshCcw } from "lucide-react";
import { useModal } from "@stores/modal-store";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@components/common/tooltip";
import useTranslator from "@hooks/use-translator";

interface Props {
  user: DictType;
}
const RefreshUserInvite = ({ user }: Props) => {
  const modal = useModal();
  const { translate } = useTranslator();

  const hasAcceptedInvite = user?._invitation?.is_accepted;

  if (hasAcceptedInvite) {
    return <span className="w-8" />;
  }

  return (
    <Tooltip>
      <TooltipTrigger>
        <Button
          onClick={() => {
            modal.onOpen();
            modal.setContext("invite");
            modal.setMetaData(user);
          }}
          size={"icon"}
          variant={"ghost"}
        >
          <RefreshCcw size={14} />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{translate(`Refresh Invite`)}</TooltipContent>
    </Tooltip>
  );
};

export default RefreshUserInvite;
